<template>
    <div class="sidebar" :class="{ open: open }">
        <div v-if="isMobile" class="collapser" @click="open = !open">
            <img class="icon" src="img/icons/ico-chevron-up.svg">
            <h5 v-if="open" class="title">Sair da Simulação</h5>
            <h5 v-else class="title">Iniciar Simulação</h5>
        </div>
        <div class="sidebar-content">
            <img v-if="!isMobile" src="img/Logo.svg" alt="App Logo" class="logo">
            <form-adicionar-ativo ref="modalAdicionarAtivo" @acaoRealizada="tratarAcaoModal"></form-adicionar-ativo>
        </div>
    </div>
    <!-- <ContentWrapper class="sidebar-wrapper">
        

        <modal-login ref="modalLogin" @acaoRealizada="tratarAcaoModal"></modal-login>
        <modal-salvar-carteira ref="modalSalvarCarteira" @acaoRealizada="tratarAcaoModal"></modal-salvar-carteira>
    </ContentWrapper> -->
</template>

<script>
import Vue from "vue"
import Multiselect from "vue-multiselect"
import { Money } from 'v-money'
import FormAdicionarAtivo from "@/app/components/Forms/FormAdicionarAtivo";
import ModalLogin from "@/app/components/Modals/ModalLogin";
import ModalSalvarCarteira from "@/app/components/Modals/ModalSalvarCarteira";
import moment from 'moment';
import SimuladorService from '@/app/services/Simulador/simulador.service'

export default {
    components: {
        FormAdicionarAtivo,
        ModalLogin,
        ModalSalvarCarteira
    },
    data() {
        return {
            datas: {
                maiorData: undefined,
                menorData: undefined
            },
            open: false
        }
    },
    methods: {
        openModalAdicionarAtivo() {
            this.$refs.modalAdicionarAtivo.abrir();
        },
        tratarAcaoModal(acao) {
            this.open = false;
            this.$emit('acaoRealizada', acao);
        },
        formatarData(data) {
            return moment(data ?? new Date()).format("DD/MM/YYYY");
        },
        openModalSalvar() {
            this.$refs.modalSalvarCarteira.abrir();
        },
        openModalLogin() {
            this.$refs.modalLogin.abrir();
        },
        openLogout(scope) {                  
            this.$router.push({ path: 'principal', query: { token: null }});
            this.$store.commit("setCarteiraAtualSalva", false);
            this.$store.commit("setLogado", false);
            document.location.reload(true)           
        }
    },
    computed: {
        carteiraSalva() {
            return this.$store.getters.getCarteiraAtualSalva;
        },
        emailSalvo() {
            return this.$store.getters.getEmailSalvo;
        },
        isMobile() {
            return this.$mq != 'desktop';
        }
    },
    watch: {
        '$store.state.datas': {
            handler(n, o) {
                this.datas = this.$store.getters.getDatasPeriodo;
            },
            deep: true
        },
        open(val) {
            if (val) {
                document.body.classList.add('menu-open');
            } else {
                document.body.classList.remove('menu-open');
            }
        }
    },
    beforeMount() {
        this.datas = this.$store.getters.getDatasPeriodo;
    },
    beforeDestroy() {
        document.body.classList.remove('menu-open');
    }
}
    
</script>

<style lang="scss">
    .sidebar-wrapper {
        overflow: hidden;
    }

    .sidebar {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 320px;
        background: white;
        box-shadow: 4px 2px 42px rgba(0, 0, 0, 0.04);
        padding: 32px 16px;
        z-index: 10;
        overflow-y: auto;

        .collapser {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 80px;
            transition: margin 1s;

            .icon {
                margin-bottom: 12px;
                transition: 1s;
            }
        }

        .sidebar-content {
            flex: 1;
            display: flex;
            flex-direction: column;
            
            .logo {
                max-width: 128px;
                margin-bottom: 56px;
            }
        }
    }

    .pikaday-header {
        max-width: 130px;
        padding-right: 0;
        z-index: 2;
        background: transparent;
    }

    .pikaday-header-icon {
        margin-left: -24px;
    }

    // Mobile
    .mobile .sidebar {
        top: auto;
        bottom: 0;
        width: 100%;
        height: 80px;
        padding-top: 0;
        padding-bottom: 0;
        transition: height 1s;
        overflow: hidden;

        .sidebar-content {
            height: 0;
            overflow: hidden;
        }

        &.open {
            top: 0;
            bottom: 0;
            height: 100%;
            padding-bottom: 32px;
            overflow: auto;
            animation: open-sidebar 1s;

            .collapser {
                .icon {
                    transform: rotate(180deg);
                }
            }

            .sidebar-content {
                height: unset;
            }
        }
    }

    @media (max-width: 985px) {
        body.menu-open {
            overflow: hidden !important;
        }
    }

    @keyframes open-sidebar {
        from { top: calc(100% - 80px); }
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>